/* No 'use client': `PoweredByBazak` renders this on the server for the verify page. */

export type NewTabLabelling = {
  linkProps: { id?: string; 'aria-labelledby'?: string };
  hintId: string;
};

/**
 * A labelled link names itself through `aria-labelledby` (its own label, then the hint) rather than
 * appending the hint to `aria-label`, which PostHog autocapture records and should keep saying what
 * the link says.
 */
export function newTabLabelling({
  id,
  ariaLabel,
  hint,
  generatedId,
}: {
  id?: string;
  ariaLabel?: string;
  hint: string | null;
  /** From `useId()`. */
  generatedId: string;
}): NewTabLabelling {
  const hintId = `${generatedId}hint`;
  if (!ariaLabel || !hint) {
    return { linkProps: { id }, hintId };
  }
  const linkId = id ?? `${generatedId}link`;
  return { linkProps: { id: linkId, 'aria-labelledby': `${linkId} ${hintId}` }, hintId };
}

/**
 * `data-tts-ignore` keeps the hint out of the read-aloud word highlighter, which walks the
 * message's text nodes; `ph-no-capture` keeps it out of autocapture's `$el_text`, and
 * `select-none` out of copied text.
 */
export function NewTabHintText({ id, hint }: { id?: string; hint: string }) {
  return (
    <span
      id={id}
      className="ph-no-capture sr-only select-none"
      data-tts-ignore=""
      data-new-tab-hint=""
    >
      {` ${hint}`}
    </span>
  );
}
